import React from 'react';
import { Target, Trophy, Shield } from 'lucide-react';
import { ArrowRight, ArrowLeft } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';

const WhyChooseUs = () => {
  // const navigate = useNavigate();
  const handleBackClick = () => {
    // Navigate back to main page
    // navigate('/aboutus/about-us');

    // Use a small timeout to ensure navigation completes before trying to open dropdown
    setTimeout(() => {
      // Custom event to communicate with navbar component
      const event = new CustomEvent('openNavDropdown', {
        detail: {
          section: 'whyMaxiom', // The Services section
          subsection: 0  // Index of "Investment Advisory" in the items array
        }
      });
      window.dispatchEvent(event);
    }, 100);
  };

  const coreValues = [
    {
      icon: Target,
      label: 'Our Purpose',
      sublabel: 'To enable every family build a lasting legacy'
    },
    {
      icon: Trophy,
      label: 'Our Mission',
      sublabel: 'Provide unbiased investing aided by tech powered research'
    },
    {
      icon: Shield,
      label: 'Our Values',
      sublabel: 'Client first, Utmost transparency and Integrity'
    }
  ];

  return (
    <div className="relative bg-gradient-to-br from-[#113262] to-[#113262] isolate min-h-[75vh] flex items-center">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 lg:pt-36">
        {/* Back Button - now placed in normal flow, above intro text */}
        <button
          onClick={handleBackClick}
          className="flex items-center gap-2 text-orange-400 hover:text-orange-600 transition-all duration-300 font-medium text-sm mb-6 opacity-60 hover:opacity-100 mb-6 opacity-60 hover:opacity-100"
        >
          <ArrowLeft className="w-4 h-4 transition-transform duration-300 group-hover:-translate-x-0.5" />
          <span className="hidden sm:inline">Back to About Us</span>
          <span className="sm:hidden">Back</span>
        </button>

        {/* Introduction Text */}
        <div className="max-w-3xl mx-auto mb-8">
          <p className="text-lg md:text-xl text-white/90 leading-relaxed text-center">
            We started Maxiom with a simple idea: wealth management should be transparent, 
            accessible, and built on research-backed principles. 
          </p>
        </div>

        {/* Core Values - Circular Layout for Desktop */}
        <div className="hidden lg:flex relative justify-center items-center min-h-[300px]">
          {/* First Circle - Our Purpose */}
          <div 
            className="absolute bg-white rounded-full shadow-lg flex flex-col items-center justify-center text-center p-6 z-30 transition-all duration-300 hover:shadow-xl hover:bg-gray-200 cursor-pointer"
            style={{
              width: '280px',
              height: '280px',
              left: '27.5%',
              transform: 'translateX(-50%)',
              transformOrigin: 'center center',
              transition: 'all 0.3s ease-in-out'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateX(-50%) scale(1.1)';
              e.currentTarget.style.zIndex = '40';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateX(-50%)';
              e.currentTarget.style.zIndex = '30';
            }}
          >
            <div className="p-3 bg-[#113262] rounded-full mb-4">
              <Target className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-[#113262] mb-2">{coreValues[0].label}</h3>
            <p className="text-gray-600 text-sm leading-relaxed px-4 line-clamp-3 h-[60px] flex items-center justify-center text-center">{coreValues[0].sublabel}</p>
          </div>

          {/* Second Circle - Our Mission (overlapping center) */}
          <div 
            className="absolute bg-white rounded-full shadow-lg flex flex-col items-center justify-center text-center p-6 z-20 transition-all duration-300 hover:shadow-xl hover:bg-gray-200 cursor-pointer"
            style={{
              width: '280px',
              height: '280px',
              left: '50%',
              transform: 'translateX(-50%)',
              transformOrigin: 'center center',
              transition: 'all 0.3s ease-in-out'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateX(-50%) scale(1.1)';
              e.currentTarget.style.zIndex = '40';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateX(-50%)';
              e.currentTarget.style.zIndex = '20';
            }}
          >
            <div className="p-3 bg-[#1C52A0] rounded-full mb-4">
              <Trophy className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-[#113262] mb-2">{coreValues[1].label}</h3>
            <p className="text-gray-600 text-sm leading-relaxed px-4 line-clamp-3 h-[60px] flex items-center justify-center text-center">{coreValues[1].sublabel}</p>
          </div>

          {/* Third Circle - Our Values */}
          <div 
            className="absolute bg-white rounded-full shadow-lg flex flex-col items-center justify-center text-center p-6 z-10 transition-all duration-300 hover:shadow-xl hover:bg-gray-200 cursor-pointer"
            style={{
              width: '280px',
              height: '280px',
              left: '72.5%',
              transform: 'translateX(-50%)',
              transformOrigin: 'center center',
              transition: 'all 0.3s ease-in-out'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateX(-50%) scale(1.1)';
              e.currentTarget.style.zIndex = '40';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateX(-50%)';
              e.currentTarget.style.zIndex = '10';
            }}
          >
            <div className="p-3 bg-[#436FB0] rounded-full mb-4">
              <Shield className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-[#113262] mb-2">{coreValues[2].label}</h3>
            <p className="text-gray-600 text-sm leading-relaxed px-4 line-clamp-3 h-[60px] flex items-center justify-center text-center">{coreValues[2].sublabel}</p>
          </div>
        </div>

        {/* Mobile Layout - Stack vertically on small screens */}
        <div className="lg:hidden flex flex-col space-y-4 max-w-xl mx-auto">
          {coreValues.map((value, index) => (
            <div 
              key={index}
              className="bg-white/10 rounded-xl border border-white/20 p-4 transition-all duration-300 hover:border-[#F49611]"
            >
              <div className="flex items-center gap-4">
                <div className={`p-2 sm:p-3 bg-gradient-to-br ${index === 1 ? 'from-[#F49611] to-[#955C0A]' : 'from-[#1C52A0] to-[#0A1E3A]'} rounded-lg`}>
                  <value.icon className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white">{value.label}</h3>
                  <p className="text-white/80">{value.sublabel}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;